module.exports = __webpack_public_path__ + "media/common/BlocklyLesson/statics/selectImage-fb93f97466284efd7ccfff1fa3af381b.png";